import urls from '@/legacy/config/env';
import api from '@/legacy/services/api';
import { buildQueryString } from '@/shared/utils/buildQueryString';

import type { AvailableDelegationsResponseDTO } from '../types';

// `api`, not `authApi`: like its `/login/switch-credentials` and `/login/user/permissions-configuration`
// siblings this lives on the dashboard host and is answered against the caller's CURRENT
// credential, which only the `api` request interceptor attaches.
export const fetchAvailableDelegations = async (
	company?: number,
): Promise<AvailableDelegationsResponseDTO> => {
	const qs = buildQueryString({ company });
	const url = qs
		? `${urls.auth.loginAvailableDelegations}?${qs}`
		: urls.auth.loginAvailableDelegations;

	const response = await api.get<AvailableDelegationsResponseDTO>(url);

	return response.data;
};
